import { TENANT } from '../../../constants';
import * as project from '../services/project';
import { ActionTypes } from '../types/action-types';

export const resetProject = () => async dispatch => {
    dispatch({
        type: ActionTypes.PROJECT_SELECTED,
        ...project.defaultProject()
    });
};

export const switchProject = (session: string, projectId: string, name: string) => async dispatch => {
    if (!projectId || TENANT.NO_TENANT === projectId) {
        dispatch(resetProject());
    } else {
        const auth = await project.getAuth(session, projectId);
        const integrations = await project.getIntegrations(auth, projectId);
        dispatch({
            type: ActionTypes.PROJECT_SELECTED,
            id: projectId,
            name,
            auth,
            integrations
        });
    }
};




// WEBPACK FOOTER //
// ./src/sub-projects/tenant/actions/project.ts